import authAxios from '@/auth/auth-axios';

export default class BuilderService {
  static async build(
    { scaffold, schema, originalProject },
    retry = 0,
  ) {
    const body = {
      scaffoldId: scaffold.id,
      version: scaffold.version,
      schema,
      originalProjectId: originalProject
        ? originalProject.id
        : null,
    };

    const axios = await authAxios();

    return axios
      .post(`/project`, body)
      .then((response) => {
        return response.data.id;
      })
      .catch((error) => {
        try {
          if (!error.response) {
            if (retry > 3) {
              throw new Error();
            }

            return BuilderService.build(
              { scaffold, schema, originalProject },
              retry + 1,
            );
          }

          if (
            error.response.status !== 400 &&
            error.response.status !== 429
          ) {
            if (retry > 3) {
              throw new Error();
            }

            return BuilderService.build(
              { scaffold, schema, originalProject },
              retry + 1,
            );
          }

          const message = error.response.data;
          const errorWithCode = new Error(message);
          errorWithCode.code = error.response.status;
          return Promise.reject(errorWithCode);
        } catch (err) {
          return Promise.reject(new Error());
        }
      });
  }
}
